import { Geotab, Group } from "@fairfleet/geotab";
import { useMutation, useQueryClient } from "@tanstack/react-query";

async function addOrUpdateGroup(groupData: {
  geotabClient: Geotab;
  name: string;
  comment: string;
  parentId: string;
  method: string;
  groupId?: string;
}) {
  const { geotabClient, name, comment, parentId, method, groupId } = groupData;

  const result = await geotabClient.call(method, {
    typeName: "Group",
    entity: {
      name,
      comments: comment,
      parent: { id: parentId },
      isGlobalReportingGroup: false,
      color: {
        r: 255,
        g: 69,
        b: 0,
        a: 255,
      },
      ...(groupId && { id: groupId }),
    },
  });

  return result as Group;
}

export function useAddOrUpdateGroup() {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: addOrUpdateGroup,
    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: ["group"],
      });
    },
  });
}
